<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <form autocomplete="off">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>{{ formIcon }}</md-icon>
            </div>
            <h4 v-if="!requesting" class="title">
              Route "{{ route.name }}" perioden
            </h4>
          </md-card-header>
          <md-card-content>
            <time-line plain type="simple">
              <time-line-item-route-period
                inverted
                badge-type="primary"
                badge-icon="schedule"
                v-for="(period, index) in this.dataPeriods"
                :key="index"
                v-model="routePeriods[index]"
                :data="period"
              ></time-line-item-route-period>
            </time-line>
          </md-card-content>

          <md-card-actions>
            <md-button
              native-type="button"
              @click.native.prevent="goBack"
              v-bind:class="{
                'md-primary': !formTouched,
                'md-warning': formTouched
              }"
              :disabled="requesting"
              >Terug</md-button
            >
            <md-button
              native-type="button"
              @click.native.prevent="handleAddPeriod(routeId())"
              class="md-success"
              :disabled="requesting"
              >Route periode toevoegen
            </md-button>
          </md-card-actions>
        </md-card>
      </form>
    </div>
    <div class="md-layout-item md-size-100" v-if="!requesting">
      <md-card class="md-card-calendar">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>{{ formIcon }}</md-icon>
          </div>
          <h4 v-if="!requesting" class="title">
            Voorbeeld route "{{ route.name }}" van actieve dagen
          </h4>
        </md-card-header>
        <md-card-content>
          <fullCalendar
            locale="nl"
            ref="calendar"
            defaultView="dayGridMonth"
            :valid-range="calendarValidRange"
            :plugins="calendarPlugins"
            :events="getEvents"
            :first-day="1"
            :selectable="true"
            @dateClick="dateClick"
            :header="header"
            :buttonIcons="buttonIcons"
            :selectHelper="true"
            :editable="false"
            :weekNumbers="true"
            allDayText="Gehele dag"
          />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { TimeLine, TimeLineItemRoutePeriod } from "@/components";
import FullCalendar from "@fullcalendar/vue";
import nlLocale from "@fullcalendar/core/locales/nl";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import RoutesMethods from "./RoutesMethods.js";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {
    TimeLine,
    TimeLineItemRoutePeriod,
    FullCalendar
  },
  data() {
    return {
      responsive: false,
      requesting: false,
      route: {},
      routePeriods: [],
      holidays: [],
      calendarPlugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
      header: {
        center: "",
        right: "prev,next"
      },
      buttonIcons: {
        close: "fa-times",
        prev: "left-single-arrow",
        next: "right-single-arrow",
        prevYear: "fa-angle-double-left",
        nextYear: "fa-angle-double-right"
      }
    };
  },
  computed: {
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "schedule";
      }
      return "schedule";
    },
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "simple";
    },
    formTouched: function() {
      return false;
    },
    dataPeriods: function() {
      var periods = [];

      if (this.routePeriods === undefined) {
        return periods;
      }

      for (var i in this.routePeriods) {
        if (this.routePeriods[i].id.length !== 36) {
          continue;
        }

        periods.push(this.routePeriods[i]);
      }

      return periods;
    },
    calendarValidRange: function() {
      return {
        start: this.calanderGetStartDate,
        end: this.calanderGetStopDate
      };
    },
    calanderGetStartDate: function() {
      var startDate = new Date(today);
      startDate.setUTCDate(startDate.getUTCDate() - 40);
      return RoutesMethods.formatDate(
        startDate.getUTCFullYear() +
          "-" +
          (startDate.getUTCMonth() + 1) +
          "-" +
          startDate.getUTCDate()
      );
    },
    calanderGetStopDate: function() {
      var stopDate = new Date(today);
      stopDate.setUTCDate(stopDate.getUTCDate() + 180);
      return RoutesMethods.formatDate(
        stopDate.getUTCFullYear() +
          "-" +
          (stopDate.getUTCMonth() + 1) +
          "-" +
          stopDate.getUTCDate()
      );
    },
    calendarGetDateRangeArray: function() {
      var dates = [];
      var startDate = this.calanderGetStartDate;
      var stopDate = this.calanderGetStopDate;

      var date = new Date(startDate);
      dates.push(startDate);

      while (
        stopDate >
        RoutesMethods.formatDate(
          date.getUTCFullYear() +
            "-" +
            (date.getUTCMonth() + 1) +
            "-" +
            date.getUTCDate()
        )
      ) {
        date.setUTCDate(date.getUTCDate() + 1);
        dates.push(
          RoutesMethods.formatDate(
            date.getUTCFullYear() +
              "-" +
              (date.getUTCMonth() + 1) +
              "-" +
              date.getUTCDate()
          )
        );
      }

      return dates;
    },
    getEvents: function() {
      var events = [];
      var dates = this.calendarGetDateRangeArray;

      for (var i in dates) {
        if (this.isDateHoliday(dates[i])) {
          events.push({
            title: this.getHolidayNameByDate(dates[i]),
            start: new Date(dates[i]),
            className: "event-red",
            allDay: true
          });

          continue;
        }

        var dayStatus = RoutesMethods.getperiodDayStatusByDate(
          dates[i],
          RoutesMethods.getperiodByDate(dates[i], this.dataPeriods)
        );
        events.push({
          title: dayStatus === 1 ? "Actief" : "Inactief",
          start: new Date(dates[i]),
          className: dayStatus === 1 ? "event-green" : "event-red",
          allDay: true
        });
      }

      return events;
    }
  },
  methods: {
    init() {
      this.loadRoute();
      this.loadRoutePeriods();
      this.loadHolidays();
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    goBack() {
      this.$router.push("/routes/overview/");
    },
    routeId() {
      return this.$route.params.id;
    },
    loadRoute() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes/" + this.$route.params.id).then(
        response => {
          this.route = response.data.route;

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutePeriods() {
      this.requesting = true;
      this.$http
        .get(this.$apiBaseUrl + "routes/" + this.$route.params.id + "/periods")
        .then(
          response => {
            this.routePeriods = RoutesMethods.reformatLoadedRoutePeriods(
              response.data.routePeriods
            );
            this.requesting = false;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadHolidays() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "holidays").then(
        response => {
          this.holidays = response.data.nationalHolidays;
          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            this.generateDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van feestdagen",
              "add_alert",
              "danger",
              0
            );
          }
        }
      );
    },
    isDateHoliday(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return true;
        }
      }

      return false;
    },
    getHolidayNameByDate(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return this.holidays[i].name;
        }
      }

      return "";
    },
    handleAddPeriod(id) {
      this.$router.push("/routes/periods/" + id + "/add/");
    },
    dateClick: function(info) {
      // // on select we show the Sweet Alert modal with an input
      // Swal.fire({
      //   title: "Create an Event",
      //   html: `<div class="md-field md-theme-default">
      //     <input type="text" id="md-input" class="md-input">
      //     </div>`,
      //   showCancelButton: true,
      //   confirmButtonClass: "md-button md-success",
      //   cancelButtonClass: "md-button md-danger",
      //   buttonsStyling: false
      // }).then(() => {
      //   var eventTitle = document.getElementById("md-input").value;
      //   if (eventTitle) {
      //     let calendarApi = this.$refs.calendar.getApi();
      //     calendarApi.addEvent({
      //       title: eventTitle,
      //       start: info.dateStr,
      //       allDay: true
      //     });
      //   }
      // });
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>
<style lang="scss">
.md-card {
  .md-card-actions {
    border: none;
  }
  .md-card-content {
    padding: 10px !important;
    line-height: 1.25em !important;
  }
}

.md-layout {
  .md-layout-item {
    padding-right: 5px;
    padding-left: 5px;
  }
}

#fullCalendar {
  min-height: 300px;
}

.md-card-calendar {
  .md-card-content {
    padding: 0 !important;
  }
}

.text-center {
  text-align: center;
}

.md-datepicker-days {
  .md-datepicker-day-button {
    height: 25px;
    line-height: 25px;
  }
}
.md-datepicker-day-button {
  font-size: 0.75rem;
}
</style>
